import React from 'react';
import { Input } from '../../assets/styled/Element';
import styled from '@emotion/styled';
import { Layout } from '../../configs/ui/constant';
import { MySelect } from '../Select/Select';
import {
   Box,
   IconButton as MuiIconButton,
   TextField,
   InputAdornment,
} from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faMinus } from '@fortawesome/pro-regular-svg-icons';

export const TitleLabel = styled('div')`
   //color: ${Layout.primary};
   //opacity: 0.25;
   //color:rgba(0,0,0,0.75);
   font-size: ${(props) => props.Fs && props.Fs};
`;

const InputContainer = styled.div`
   position: relative;
   display: inline-block;
`;

const StyledIconButton = styled.button`
   position: absolute;
   top: 50%;
   transform: translateY(-50%);
   background: none;
   border: none;
   cursor: pointer;
   font-size: 16px;
   color: #515d69;
   padding: 0.5rem;
   height: 40px !important;
   &:hover {
      color: ${Layout.primary};
   }
   &:disabled {
      color: #ccc;
      cursor: not-allowed;
   }
   z-index: 1;
`;

const MinusIcon = styled(StyledIconButton)`
   left: 0.5rem;
`;

const PlusIcon = styled(StyledIconButton)`
   right: 0.5rem;
`;

export const LabelInput = ({ label, inputProps }) => {
   return (
      <React.Fragment>
         <TitleLabel>{label}</TitleLabel>
         <Input {...inputProps} />
      </React.Fragment>
   );
};

export const LabelSelect = ({ label, inputProps }) => {
   return (
      <React.Fragment>
         <TitleLabel>{label}</TitleLabel>
         <MySelect {...inputProps} />
      </React.Fragment>
   );
};

// New: LabelInputSpin Component
export const LabelInputSpin = ({ label, value = 0, onChange }) => {
   const handleIncrement = () => onChange(value + 1);
   const handleDecrement = () => onChange(Math.max(value - 1, 0)); // ไม่ให้ค่าต่ำกว่า 0

   return (
      <Box>
         <TitleLabel>{label}</TitleLabel>
         <InputContainer>
            <MinusIcon onClick={handleDecrement}>
               <FontAwesomeIcon icon={faMinus} />
            </MinusIcon>
            <Input
               value={value}
               onChange={(e) => onChange(parseInt(e.target.value, 10) || 0)}
               textAlign='center'
               padding='0.5rem 2.5rem' // เผื่อพื้นที่สำหรับไอคอน
               style={{ height: '40px' }} // หรือใช้ style ในการปรับ
            />
            <PlusIcon onClick={handleIncrement}>
               <FontAwesomeIcon icon={faPlus} />
            </PlusIcon>
         </InputContainer>
      </Box>
   );
};
